import { render, staticRenderFns } from "./ParametrosVerConfiguracaoAtual.vue?vue&type=template&id=b54f6e82&scoped=true"
import script from "./ParametrosVerConfiguracaoAtual.vue?vue&type=script&lang=js"
export * from "./ParametrosVerConfiguracaoAtual.vue?vue&type=script&lang=js"
import style0 from "./ParametrosVerConfiguracaoAtual.vue?vue&type=style&index=0&id=b54f6e82&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54f6e82",
  null
  
)

export default component.exports